<template>
  <div class="container">
    <h1 class="py-4">パートナー管理</h1>
    <div class="pb-4">
      <div class="form-row">
        <div class="form-group col-md-12">
          <label for="l-partnerName">パートナー名*</label><br />

          <input
            v-model="partnerName"
            placeholder="パートナー名"
            class="input-boot"
          />
          <label class="txt-error" v-if="!$v.partnerName.required">
            パートナー名を入力してください
          </label>
        </div>
        <div class="form-group col-md-12">
          <label for="l-type">業種*</label><br />
          <select v-model="type" class="input-boot">
            <option disabled value="">選択してください</option>
            <option
              v-for="option in this.industries"
              :value="option.value"
              :key="option.value"
            >
              {{ option.display }}
            </option>
          </select>
          <label class="txt-error" v-if="!$v.type.selected">
            業種を入力してください
          </label>
        </div>
        <div class="form-group col-md-12">
          <label for="l-url">URL</label><br />
          <input v-model="url" placeholder="URL" class="input-boot" />
        </div>
        <div class="form-group col-md-12">
          <label for="l-pid">PID*</label><br />
          <input v-model="pid" placeholder="PID" class="input-boot" />
          <label class="txt-error" v-if="!$v.pid.required">
            PIDを入力してください
          </label>
        </div>
        <div class="form-group col-md-auto">
          <label for="l-type">ロゴ画像（180x100）</label><br />
          <input type="file" id="partnerImage" @change="imageSelected" />
          <img v-if="previewImage" :src="previewImage" />
          <br />
        </div>
        <div class="form-group col-md-12">
          <label for="l-pid">日本語紹介文（150文字以内）</label><br />
          <textarea 
            v-model="descriptionJP"
            maxlength="150"
            placeholder="日本語紹介文（150文字以内）"
            class="input-boot-textArea"
          />
          <label class="txt-error" v-if="!$v.descriptionJP.maxLength">
            150文字以内で入力してください
          </label>
        </div>
        <div class="form-group col-md-12">
          <label for="l-pid">英語紹介文（300文字以内）</label><br />
          <textarea 
            v-model="descriptionEN"
            placeholder="英語紹介文（300文字以内）"
            maxlength="300"
            class="input-boot-textArea"
          />
          <label class="txt-error" v-if="!$v.descriptionEN.maxLength">
            300文字以内で入力してください
          </label>
        </div>
      </div>
      <div class="text-right">
        <button class="btn btn-primary mr10" @click="createPartner">
          登録
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase";
import master from "@/constants/MasterEnum";
import { required, maxLength } from "vuelidate/lib/validators";

export default {
  name: "CreatePartner",
  mixins: [master],
  data() {
    return {
      db: firebase.firestore(),
      previewImage: null,
      loading: true,
      currentPage: 1,
      perPage: 10,
      partnerName: "",
      descriptionEN: "",
      descriptionJP: "",
      type: "",
      imageName: "",
      url: "",
      pid: "",
      partners: [],
      file: null,
    };
  },
  validations: {
    partnerName: {
      required,
    },
    type: {
      selected: required,
    },
    pid: {
      required,
    },
    descriptionJP: {
      maxLength: maxLength(150),
    },
    descriptionEN: {
      maxLength: maxLength(300),
    },
  },
  created: function() {},
  methods: {
    async createPartner() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        //console.log("invalid");
      } else {
        let doc = {
          partnerName: this.partnerName,
          pid: this.pid,
          url: this.url,
          type: this.type,
          descriptionEN:this.descriptionEN,
          descriptionJP:this.descriptionJP
        };
        if (this.imageName !== "") {
          let storageRef = firebase.storage().ref();
          let imageRef = storageRef.child("partners/" + this.imageName);
          await imageRef.put(this.file);
          let imageUrl = await imageRef.getDownloadURL();
          doc.imageUrl = imageUrl;
        }
        let partnerRef = this.db.collection("partners").doc();
        await partnerRef.set(doc);
        this.$router.push({
          name: "Partners",
        });
      }
    },
    imageSelected(e) {
      const file = e.target.files[0];
      if (file !== undefined) {
        let fileNameSplit = file.name.split(".");
        let fileFormat = fileNameSplit[fileNameSplit.length - 1];
        if (
          fileFormat == "jpg" ||
          fileFormat == "jpeg" ||
          fileFormat == "png"
        ) {
          this.imageName = file.name;
          this.file = file;
          this.previewImage = URL.createObjectURL(file);
        } else {
          this.file = null;
          this.imageName = null;
          this.previewImage = null;
        }
      } else {
        this.imageName = null;
        this.previewImage = null;
        this.file = null;
      }
    },
  },
};
</script>
